import { Link } from 'react-router-dom'
import PageHero from '@components/common/PageHero'
import { productCategories } from '@data/categories'
import { services } from '@data/services'

const FAMILY = "'DM Sans', sans-serif"
const AMBER  = '#ed9716'
const TEXT   = '#2d2d2d'
const MUTED  = '#666'

function SitemapSection({ title, children }) {
  return (
    <div style={{ marginBottom: '44px' }}>
      <h2 style={{
        fontFamily: FAMILY, fontSize: '11px', fontWeight: 700,
        letterSpacing: '0.13em', textTransform: 'uppercase',
        color: AMBER, margin: '0 0 10px',
      }}>
        {title}
      </h2>
      <div style={{ width: '24px', height: '2px', background: AMBER, marginBottom: '20px' }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {children}
      </div>
    </div>
  )
}

function SitemapLink({ to, label, description }) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', padding: '7px 0', borderBottom: '1px solid #f0f0f0' }}>
      <Link
        to={to}
        style={{
          fontFamily: FAMILY, fontSize: '14.5px', fontWeight: 500,
          color: '#065e32', textDecoration: 'none', minWidth: '240px', flexShrink: 0,
          transition: 'color 0.2s',
        }}
        onMouseEnter={e => e.currentTarget.style.color = AMBER}
        onMouseLeave={e => e.currentTarget.style.color = '#065e32'}
      >
        {label}
      </Link>
      {description && (
        <span style={{ fontFamily: FAMILY, fontSize: '13px', color: MUTED }}>
          {description}
        </span>
      )}
    </div>
  )
}

export default function SitemapPage() {
  return (
    <>
      <PageHero
        title="Sitemap"
        breadcrumbs={[
          { label: 'Home', to: '/' },
          { label: 'Sitemap' },
        ]}
      />

      <div style={{ background: '#ffffff' }}>
        <div style={{
          maxWidth: 'var(--container-max)', margin: '0 auto',
          padding: '60px var(--container-padding) 80px',
        }}>

          <SitemapSection title="Main Pages">
            <SitemapLink to="/"        label="Home"       description="Welcome to Salient Agrinutrition" />
            <SitemapLink to="/about"   label="About Us"   description="Our story, mission, values, and global partnerships" />
            <SitemapLink to="/contact" label="Contact Us" description="Office locations, phone numbers, and enquiry form" />
          </SitemapSection>

          <SitemapSection title="Products">
            <SitemapLink to="/products" label="All Products" description="Browse our full range of livestock nutritional solutions" />
            {productCategories.map(cat => (
              <SitemapLink
                key={cat.id}
                to={`/products?category=${cat.id}`}
                label={cat.label}
                description={cat.description}
              />
            ))}
          </SitemapSection>

          <SitemapSection title="Services">
            <SitemapLink to="/services" label="All Services" description="Our full range of technical and support services" />
            {services.map(s => (
              <SitemapLink
                key={s.id}
                to={`/services/${s.slug}`}
                label={s.name}
                description={s.tagline}
              />
            ))}
          </SitemapSection>

          <SitemapSection title="News & Blog">
            <SitemapLink to="/blog" label="News & Blog" description="Latest news, insights, and technical articles" />
          </SitemapSection>

          <SitemapSection title="Legal">
            <SitemapLink to="/privacy-policy" label="Privacy Policy" description="How we collect and use your information" />
            <SitemapLink to="/terms-of-use"   label="Terms of Use"   description="Terms governing use of this website" />
          </SitemapSection>

        </div>
      </div>
    </>
  )
}
